import { api } from './client';
import type { ColorAllowance, ShirtColor, ValidateExternalOrderResult } from '../types';

export type ExternalOrderRow = {
  externalId: string;
  firstName: string;
  ticketCount: number;
  orderedShirts: number;
  allowance: number;
  remaining: number;
  byColor: Record<ShirtColor, ColorAllowance>;
  used: boolean;
};

export const validateExternalOrder = (firstName: string, externalOrderId: string) =>
  api.post<ValidateExternalOrderResult>('/external-orders/validate', {
    firstName,
    externalOrderId,
  });

export const listExternalOrders = (q?: string, opts?: { limit?: number; offset?: number }) => {
  const params = new URLSearchParams();
  if (q) params.set('q', q);
  if (opts?.limit !== undefined) params.set('limit', String(opts.limit));
  if (opts?.offset) params.set('offset', String(opts.offset));
  const search = params.toString();
  return api.get<{
    externalOrders: ExternalOrderRow[];
    total: number;
    used: number;
    shirtQuotaPerColor: number;
  }>(`/admin/external-orders${search ? `?${search}` : ''}`);
};
